import team1 from '../../public/team/team1.webp';
import team2 from '../../public/team/team2.webp';
import team3 from '../../public/team/team3.webp';
import team4 from '../../public/team/team4.webp';
import team5 from '../../public/team/team5.webp';
import team6 from '../../public/team/team6.webp';
import team7 from '../../public/team/team7.webp';
import team8 from '../../public/team/team8.webp';
import team9 from '../../public/team/team9.webp';
import team10 from '../../public/team/team10.webp';
import team11 from '../../public/team/team11.webp';
import team12 from '../../public/team/team12.webp';
import team13 from '../../public/team/team13.webp';
import team14 from '../../public/team/team14.webp';
import team15 from '../../public/team/team15.webp';

import team1hover from '../../public/team/team1-hover.webp';
import team2hover from '../../public/team/team2-hover.webp';
import team3hover from '../../public/team/team3-hover.webp';
import team4hover from '../../public/team/team4-hover.webp';
import team5hover from '../../public/team/team5-hover.webp';
import team6hover from '../../public/team/team6-hover.webp';
import team7hover from '../../public/team/team7-hover.webp';
import team8hover from '../../public/team/team8-hover.webp';
import team9hover from '../../public/team/team9-hover.webp';
import team10hover from '../../public/team/team10-hover.webp';
import team11hover from '../../public/team/team11-hover.webp';
import team12hover from '../../public/team/team12-hover.webp';
import team13hover from '../../public/team/team13-hover.webp';
import team14hover from '../../public/team/team14-hover.webp';
import team15hover from '../../public/team/team15-hover.webp';

export const team = [
  {
    teamBlocks: [
      {
        alt: 'Ruslan',
        name: 'Ruslan',
        prof: <span>Founder</span>,
        image: team1,
        imageHover: team1hover,
      },
      {
        alt: 'Victoria',
        name: 'Victoria',
        prof: 'Co-Founder',
        image: team3,
        imageHover: team3hover,
      },
      {
        alt: 'Denys',
        name: 'Denys',
        prof: 'CTO',
        image: team2,
        imageHover: team2hover,
      },
    ],
  },
  {
    teamBlocks: [
      {
        alt: 'Anna',
        name: 'Anna',
        prof: 'Project Manager',
        image: team4,
        imageHover: team4hover,
      },
      {
        alt: 'Dmitriy',
        name: 'Dmitriy',
        prof: 'UX/UI Designer',
        image: team5,
        imageHover: team5hover,
      },
      {
        alt: 'Gleb',
        name: 'Gleb',
        prof: 'Graphic Designer',
        image: team6,
        imageHover: team6hover,
      },
      {
        alt: 'Alexey',
        name: 'Alexey',
        prof: 'QA Engineer',
        image: team7,
        imageHover: team7hover,
      },
    ],
  },
  {
    teamBlocks: [
      {
        alt: 'Yuriy',
        name: 'Yuriy',
        prof: 'iOS Developer',
        image: team8,
        imageHover: team8hover,
      },
      {
        alt: 'Kyrylo',
        name: 'Kyrylo',
        prof: 'iOS Developer',
        image: team9,
        imageHover: team9hover,
      },
      {
        alt: 'Pavel',
        name: 'Pavel',
        prof: 'Android Developer',
        image: team10,
        imageHover: team10hover,
      },
      {
        alt: 'Pavel',
        name: 'Pavel',
        prof: 'Android Developer',
        image: team11,
        imageHover: team11hover,
      },
    ],
  },
  {
    teamBlocks: [
      {
        alt: 'Alexey',
        name: 'Alexey',
        prof: 'Back-end Developer',
        image: team12,
        imageHover: team12hover,
      },
      {
        alt: 'Yuriy',
        name: 'Yuriy',
        prof: 'Back-end Developer',
        image: team13,
        imageHover: team13hover,
      },
      {
        alt: 'Alexandr',
        name: 'Alexandr',
        prof: 'Front-end Developer',
        image: team14,
        imageHover: team14hover,
      },
      {
        alt: 'Nikita',
        name: 'Nikita',
        prof: 'Front-end Developer',
        image: team15,
        imageHover: team15hover,
      },
    ],
  },
];
